import { useDictionary } from '@eih-netbroker/common';
import { useState } from 'react';
import { ReactComponent as CheckIcon } from '../../../../assets/icons/checkbox-circle-fill.svg';
import { ReactComponent as CopyIcon } from '../../../../assets/icons/copy2.svg';
import { useLocale } from '../../../../context/NbLocalizationContext';
import { useAccounts } from '../../../../shared/services/useAccounts';
import { cssWhen } from '../../../../shared/utils/themeUtils';
import classes from './CashPopoverContent.module.scss';
import emptyClasses from './EmptyCashPopoverContent.module.scss';

export const EmptyCashPopoverContent = () => {
  const { translation } = useLocale();
  const [isCopied, setIsCopied] = useState(false);
  const { selectedClientName, selectedAccountOrClient } = useAccounts();
  const { formatDictionaryType } = useDictionary();

  const handleCopyAccountNumber = () => {
    if (!selectedAccountOrClient.account?.depositAccountNumber) {
      return;
    }

    setIsCopied(true);
    return navigator.clipboard.writeText(selectedAccountOrClient.account?.depositAccountNumber);
  };

  return (
    <div className={classes.cash}>
      <div className={classes.cashHeader}>
        <div className={classes.cashHeaderText}>
          <h4 data-hj-suppress>{selectedClientName}</h4>
          <p className={classes.cashHeaderUser}>
            {selectedAccountOrClient?.account?.accountCategory
              ? formatDictionaryType(selectedAccountOrClient.account.accountCategory, 'accountCategoryTypes')
              : translation.header.allAccounts}
          </p>
        </div>
      </div>
      <div className={emptyClasses.empty}>
        <h4>{translation.header.cashEmpty.title}</h4>

        <div>
          <p>{translation.header.cashEmpty.text1}</p>
          <p
            className={cssWhen(emptyClasses.emptyAccount, [isCopied, emptyClasses.emptyAccountIsCopied])}
            onClick={handleCopyAccountNumber}
          >
            {selectedAccountOrClient.account?.depositAccountNumber} {isCopied ? <CheckIcon /> : <CopyIcon />}
          </p>
          <p>{translation.header.cashEmpty.text2}</p>
        </div>
      </div>
    </div>
  );
};
